var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 38,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6383",
    d: "M7.618 30.125h-.236c0-5.451-3.312-9.885-7.382-9.885v-.23c4.07 0 7.382-4.434 7.382-9.885h.236c0 5.451 3.312 9.885 7.382 9.885v.23c-4.07 0-7.382 4.434-7.382 9.885z",
    fill: "#1b2a38"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17760",
    transform: "translate(7)",
    fill: "none",
    stroke: "#1b2a38"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h1v38H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    height: 37
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniStar);
export default __webpack_public_path__ + "static/media/mini-star.b4234e684e2a82889ceeb4c6c47986bf.svg";
export { ForwardRef as ReactComponent };